var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5 2.124a2.5 2.5 0 0 0-2.5 2.5v7.213a3.487 3.487 0 0 1 1.5-.337h2.774l2.2-2.707A3.5 3.5 0 0 1 13.19 7.5h5.31c.537 0 1.045.12 1.5.337V4.624a2.5 2.5 0 0 0-2.5-2.5h-11Zm.404 2.233a.5.5 0 0 0 0 1h3.5a.5.5 0 1 0 0-1h-3.5Zm-.5 2.75a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.527 17.12h.696c.206 0 .394-.044.564-.133a.991.991 0 0 0 .405-.387c.099-.17.148-.377.148-.62a1.2 1.2 0 0 0-.148-.61.99.99 0 0 0-.405-.387 1.203 1.203 0 0 0-.564-.133h-.695v2.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 8.5A2.5 2.5 0 0 1 21 11v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 20v-5a2.5 2.5 0 0 1 2.5-2.5h3.25l2.5-3.076a2.5 2.5 0 0 1 1.94-.924h5.31ZM14 20v-6.5h2.468c.475 0 .904.1 1.287.299.383.2.685.487.905.863.227.37.34.808.34 1.318 0 .509-.113.952-.34 1.328-.22.369-.522.657-.905.864a2.749 2.749 0 0 1-1.287.298h-.94V20H14Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPress);
export default __webpack_public_path__ + "static/media/press.5e6ae2fd8f8897fd844e34c9adb9fbfd.svg";
export { ForwardRef as ReactComponent };